import { render, staticRenderFns } from "./boutBallBet.vue?vue&type=template&id=c88e50fc&scoped=true"
import script from "./boutBallBet.vue?vue&type=script&lang=js"
export * from "./boutBallBet.vue?vue&type=script&lang=js"
import style0 from "./boutBallBet.vue?vue&type=style&index=0&id=c88e50fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88e50fc",
  null
  
)

export default component.exports